import { render } from "./RuleOverviewView.vue?vue&type=template&id=125499d2&scoped=true"
import script from "./RuleOverviewView.vue?vue&type=script&lang=js"
export * from "./RuleOverviewView.vue?vue&type=script&lang=js"

import "./RuleOverviewView.vue?vue&type=style&index=0&id=125499d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125499d2"]])

export default __exports__